import React  from "react";

const withMatchingBrands = (WrappedComponent) =>
  class extends React.Component {
    constructor(props) {
      super(props);
      this.availableBrands = this.availableBrands.bind(this);
      this.matches = this.matches.bind(this);
    }

    availableBrands() {
      const { selectedBrands } = this.props;
      const available_brands = this.props.allBrands.filter((brand) => {
        if(selectedBrands[brand.key] !== false) {
          return brand;
        }
        return null;
      });
      return available_brands;
    }

    matches() {
      const { height, weight } = this.props;

      const available_sizes = this.availableBrands().reduce((result, brand) => {

        const matching_sizes = brand.sizes.filter((element) => {
          return (
            element.maxHeight >= height &&
              element.minHeight <= height &&
              element.maxWeight >= weight &&
              element.minWeight <= weight
          );
        });

        if(matching_sizes.length > 0){
          result.push({...brand, sizes: matching_sizes});
        }
        return result;
      }, []);
      return available_sizes;
    }

    render() {
      return <WrappedComponent matchingBrands={this.matches()} {...this.props}/>;
    }
  };

export default withMatchingBrands;


/** WEBPACK FOOTER **
 ** ./src/components/AvailableSizes/Base/withMatchingBrands.js
 **/